import { REGEX as e } from "@scalar/helpers/regex/regex-helpers";
//#region src/schema/helpers/get-ref-name.ts
var t = (t) => {
	if (!t) return null;
	let n = t.match(e.REF_NAME);
	return n ? n[1] : null;
}, n = /^#\/components\/schemas\/([^/]+)$/, r = (e) => {
	if (!e) return null;
	let t = e.match(n);
	return t?.[1] ? decodeURIComponent(t[1]) : null;
};
//#endregion
export { t as getRefName, r as getSchemaRefName };

//# sourceMappingURL=get-ref-name.js.map